import { Container, Grid, Box } from '@mui/material';
import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

import ResponsibleAITrainingVideosList from './ResponsibleAITrainingVideosList';

import Spacer, { spc } from '~c/components/base/spacer';
import Text from '~c/components/base/text';

interface Props {
  className?: string;
}

const ResponsibleAITrainingImpl: React.FC<Props> = ({ className }) => {
  return (
    <Container maxWidth="lg" className={className}>
      <Box py={4}>
        <Text sz="h1">Responsible AI Training Videos</Text>
        <Spacer mb={spc.between_vertical_s} />
        <Grid container spacing={10}>
          <Grid item xs={12}>
            <ResponsibleAITrainingVideosList />
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export const ResponsibleAITraining = muiStyled(ResponsibleAITrainingImpl)(
  ({ theme }) => css``
);

export default ResponsibleAITraining;
